import AccountInfo from '../../application/domain/entities/accountInfo';
import EmployerCity from '../../application/domain/entities/employerCity';
import EmployerLocation from '../../application/domain/entities/employerLocation';
import EmployerState from '../../application/domain/entities/employerState';
import Account from '../../application/domain/entities/account';
import AccountInfoDto from '../dto/req/accountInfo';
import CityDto from '../dto/req/cityDto';
import LocationDto from '../dto/req/locationDto';
import StateDto from '../dto/req/stateDto';
import AccountDto from '../dto/req/accountDto';
import AddressResDto from '../dto/res/addressResDto';
import StateCity from '../../application/domain/entities/stateCity';

export function mapStateDtoToState(stateDto: StateDto): EmployerState {
  return {
    id: stateDto.stateId,
    code: stateDto.shortForm,
    name: stateDto.name,
  };
}

export function mapCityDtoToCity(cityDto: CityDto): EmployerCity {
  return {
    id: cityDto.id,
    name: cityDto.name,
  };
}

export function mapLocationDtoToLocation(locationDto: LocationDto): EmployerLocation {
  return {
    id: locationDto.locationId,
    name: locationDto.name,
    state: locationDto.state ? mapStateDtoToState(locationDto.state) : undefined,
    isRemoteLocation: locationDto.isRemoteLocation ?? false, // Default to false if not provided
    isEverifyEnable: locationDto.isEverifyEnable ?? false, // Default to false if not provided
    isEmployeeFillingDocs: locationDto.isEmployeeFillingDocs ?? false, // Default to false if not provided
  };
}

export function mapAccountInfoDtoToAccountInfo(accountInfoDto: AccountInfoDto): AccountInfo {
  return {
    accountId: accountInfoDto.accountId,
    location: accountInfoDto.location.map((loc: LocationDto) => mapLocationDtoToLocation(loc)),
  };
}

export function mapStateCityDtoToStateCity(stateCityDto: { state: StateDto; city: string }): {
  state: EmployerState;
  city: string;
} {
  return {
    state: mapStateDtoToState(stateCityDto.state),
    city: stateCityDto.city,
  };
}

export function mapAddressResToStateCity(dto: AddressResDto): StateCity {
  return {
    state: { id: '', code: dto.state ?? '', name: '' },
    city: dto.city,
    manualCheckRecommended: dto.manualCheckRecommended,
  };
}

export function mapAccountDtoToAccount(accountDto: AccountDto): Account {
  return {
    id: accountDto.id,
    accountName: accountDto.accountName,
  };
}
